
const cardStyle = theme => ({
    cardContainer: {
        minHeight: 105,
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    },
    card: {
        cursor: "pointer",
        minHeight: "100px",
        width: "268px",
        border: "1px solid #4D4D4D",
        borderRadius: 10,
        display: "flex",
        flexDirection: "column",
        backgroundColor: "rgba(255,255,255,0.95)",
        paddingLeft: 16
    },
    iconTextWrapper: {
        display: "flex",
    },
    icons: {
        height: 18,
        width: 18
    },
    iconContainer: {
        marginTop: 13,
        maxHeight: 18
    },
    name: {
        color: "#4981C5",
        fontSize: 20,
        width: 199,
        minHeight: 44,
        paddingTop: 8,
        display: "flex",
        alignItems: "flex-end",
        fontFamily: "Proxima Nova",
        fontWeight: "bold",
        lineHeight: "24px",
        wordBreak: "break-all"
    },
    company: {
        color: "#1C1C1C",
        fontSize: 14,
        lineHeight: "17px",
        paddingRight: 11,
        fontFamily: "Proxima Nova",
    },
    state: {
        color: "#242424",
        fontSize: 14,
        fontFamily: "Proxima Nova",
        fontWeight: "bold",
        lineHeight: "17px",
    },
    Dob: {
        color: "#242424",
        fontSize: 12,
        fontWeight: 300,
        fontFamily: "Proxima Nova",
        lineHeight: "12px",
        alignSelf: "flex-end"
    },
    dobStyle: {
        fontWeight: 400
    },
    cardSelected: {
        boxShadow: "1px 3px 5px 0 rgba(0,0,0,0.5)",
        border: "2px solid #4D4D4D !important",
    },
    dobWrapper: {
        display: "flex",
        flex: "1",
        justifyContent: "space-between",
        paddingRight: 11,
        paddingBottom: 6
    },
    disabledCard: {
        cursor: "default !important",
        backgroundColor: "#cccccc"
    },
    disabledCardCursor: {
        cursor: "default !important",
    },
    disabledCardName: {
        color: "#242424 !important"
    }
})

export default cardStyle;